export default {
  toggleSideBar: state => (state.sidebar.open = !state.sidebar.open),
  toggleBpSelectionDialog: state => (state.bpSelectionDialog.display = !state.bpSelectionDialog.display),
  toggleOverrideThemeForBpsDialog: state =>
    (state.overrideThemeBpsDialog.display = !state.overrideThemeBpsDialog.display)
};
